module.exports = __webpack_public_path__ + "img/TV_Adverts_image_3.f1a22ae0.jpg";